<div class="form-container">
    <dx-form [(formData)]="formData" labelLocation="top">
        
        <!-- الصف الأول: الفرع - الاسم - التاريخ -->
        <dxi-item itemType="group" [colCount]="3">
            <dxi-item dataField="branchId" editorType="dxSelectBox" [editorOptions]="{
                dataSource: branchesdropdown,
                displayExpr: currentLang=='ar'?'nameAr':'nameEn',
                valueExpr: 'id',
                searchEnabled: true,
                showClearButton: true,
                value: DefaultBranch,
                rtlEnabled: true
            }">
                <dxo-label text="الفرع"></dxo-label>
                <dxi-validation-rule type="required" message="الفرع مطلوب"></dxi-validation-rule>
            </dxi-item>

            
            <dxi-item dataField="nameAr" editorType="dxTextBox" [editorOptions]="{
                rtlEnabled: true,
                placeholder: 'اسم الجهاز'
            }">
                <dxo-label text="الاسم"></dxo-label>
                <dxi-validation-rule type="required" message="اسم الجهاز مطلوب"></dxi-validation-rule>
            </dxi-item>
        <dxi-item dataField="nameEn" editorType="dxTextBox" [editorOptions]="{
                rtlEnabled: true,
                placeholder:  'اسم الجهاز بالانجليزي '
            }">
                <dxo-label text="الاسم"></dxo-label>
                <dxi-validation-rule type="required" message="اسم الجهاز مطلوب"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="dateOfRegistration" editorType="dxDateBox" [editorOptions]="{
                displayFormat: 'dd/MM/yyyy',
                rtlEnabled: true,
                type: 'date'
            }">
                <dxo-label text="التاريخ"></dxo-label>
            </dxi-item>
        </dxi-item>

        <!-- الصف الثاني: الموديل - Port - نوع الجهاز -->
        <dxi-item itemType="group" [colCount]="3">
            <dxi-item dataField="model" editorType="dxTextBox" [editorOptions]="{
                rtlEnabled: true,
                placeholder: 'DS-K1T320MFWX'
            }">
                <dxo-label text="الموديل"></dxo-label>
                <dxi-validation-rule type="required" message="الموديل مطلوب"></dxi-validation-rule>
            </dxi-item>

            <!-- ✅ Port نص (string) مش رقم -->
            <dxi-item dataField="port" editorType="dxTextBox" [editorOptions]="{
                rtlEnabled: true,
                placeholder: '80'
            }">
                <dxo-label text="Port"></dxo-label>
                <dxi-validation-rule type="required" message="رقم المنفذ مطلوب"></dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="deviceType" editorType="dxSelectBox" [editorOptions]="{
                dataSource: fingerPrintDeviceTypedropdown,
                displayExpr: 'name',
                valueExpr: 'code',
                rtlEnabled: true
            }">
                <dxo-label text="نوع الجهاز"></dxo-label>
                <dxi-validation-rule type="required" message="نوع الجهاز مطلوب"></dxi-validation-rule>
            </dxi-item>
        </dxi-item>

         <dxi-item itemType="group" [colCount]="2">
            <dxi-item dataField="UserName" editorType="dxTextBox" [editorOptions]="{
                rtlEnabled: true,
                placeholder: 'haik@1234'
            }">
                <dxo-label text="اسم المستخدم"></dxo-label>
              
            </dxi-item>

            <!-- ✅ Port نص (string) مش رقم -->
            <dxi-item dataField="password" editorType="dxTextBox" [editorOptions]="{ 
                rtlEnabled: true,
                placeholder: 'abc123',
                  mode: 'password'
            }">
                <dxo-label text="كلمة المرور"></dxo-label>
         
            </dxi-item>

         
        </dxi-item>




        <!-- الصف الثالث: الوصف - نوع التسجيل - IP -->
        <dxi-item itemType="group" [colCount]="3">
            <dxi-item dataField="description" editorType="dxTextBox" [editorOptions]="{
                rtlEnabled: true,
                placeholder: 'وصف الجهاز (اختياري)'
            }">
                <dxo-label text="الوصف"></dxo-label>
            </dxi-item>

            <!-- ✅ AttendanceType -->
            <dxi-item dataField="attendanceType" editorType="dxSelectBox" [editorOptions]="{
                dataSource: EmpAttendanceTypedropdown, 
                displayExpr: 'name',
                valueExpr: 'code',
                rtlEnabled: true
            }">
                <dxo-label text="نوع التسجيل"></dxo-label>
                <dxi-validation-rule type="required" message="نوع التسجيل مطلوب"></dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="ip" editorType="dxTextBox" [editorOptions]="{
                rtlEnabled: true,
                stylingMode: 'filled',
                placeholder: '192.168.1.100'
            }" cssClass="highlight-ip">
                <dxo-label text="IP"></dxo-label>
                <dxi-validation-rule type="required" message="عنوان IP مطلوب"></dxi-validation-rule>

            </dxi-item>
        </dxi-item>

        <!-- الصف الرابع: رقم التسلسل - ملف التخزين - الحالة -->
        <dxi-item itemType="group" [colCount]="3">
           
            <dxi-item dataField="serial" editorType="dxTextBox" [editorOptions]="{
                rtlEnabled: true,
                placeholder: 'رقم التسلسل (اختياري)'
            }">
                <dxo-label text="رقم التسلسل"></dxo-label>
            </dxi-item>

          
            <dxi-item dataField="CVs" editorType="dxSelectBox" [editorOptions]="{
                dataSource: EmpAttendanceDeviceCVsdropdown,
                displayExpr: 'name',
                valueExpr: 'code',
                rtlEnabled: true
            }">
                <dxo-label text="ملف التخزين"></dxo-label>
                <dxi-validation-rule type="required" message="ملف التخزين مطلوب"></dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="isActive" editorType="dxCheckBox" [editorOptions]="{
                text: 'الجهاز نشط',
                rtlEnabled: true
            }">
                <dxo-label text="الحالة"></dxo-label>
            </dxi-item>
        </dxi-item>

        <!-- ✅ الحقول الإضافية (nullable) -->
        <dxi-item itemType="group" caption="إعدادات أعمدة الاستخراج (اختياري)" [colCount]="3">
            <!-- كود البصمة - enrollid -->
            <dxi-item dataField="enrollid" editorType="dxNumberBox" [editorOptions]="{
                rtlEnabled: true,
                showSpinButtons: true,
                placeholder: 'كود البصمة'
            }">
                <dxo-label text="كود البصمة"></dxo-label>
            </dxi-item>

            <!-- عمود اليوم -->
            <dxi-item dataField="day" editorType="dxSelectBox" [editorOptions]="{
                dataSource: DeviceAttendanceConfigrationColumnsdropdown,
                displayExpr: 'name',
                valueExpr: 'code',
                rtlEnabled: true
            }">
                <dxo-label text="اليوم"></dxo-label>
            </dxi-item>

            <!-- عمود الشهر -->
            <dxi-item dataField="month" editorType="dxSelectBox" [editorOptions]="{
                dataSource: DeviceAttendanceConfigrationColumnsdropdown,
                displayExpr: 'name',
                valueExpr: 'code',
                rtlEnabled: true
            }">
                <dxo-label text="الشهر"></dxo-label>
            </dxi-item>

            <!-- عمود السنة -->
            <dxi-item dataField="year" editorType="dxSelectBox" [editorOptions]="{
                dataSource: DeviceAttendanceConfigrationColumnsdropdown,
                displayExpr: 'name',
                valueExpr: 'code',
                rtlEnabled: true
            }">
                <dxo-label text="السنة"></dxo-label>
            </dxi-item>

            <!-- عمود الساعة -->
            <dxi-item dataField="hour" editorType="dxSelectBox" [editorOptions]="{
                dataSource: DeviceAttendanceConfigrationColumnsdropdown,
                displayExpr: 'name',
                valueExpr: 'code',
                rtlEnabled: true
            }">
                <dxo-label text="الساعة"></dxo-label>
            </dxi-item>

            <!-- عمود الدقيقة -->
            <dxi-item dataField="minute" editorType="dxSelectBox" [editorOptions]="{
                dataSource: DeviceAttendanceConfigrationColumnsdropdown,
                displayExpr: 'name',
                valueExpr: 'code',
                rtlEnabled: true
            }">
                <dxo-label text="الدقيقة"></dxo-label>
            </dxi-item>

            <!-- عمود الثانية (seconed - typo في DTO) -->
            <dxi-item dataField="seconed" editorType="dxSelectBox" [editorOptions]="{
                dataSource: DeviceAttendanceConfigrationColumnsdropdown,
                displayExpr: 'name',
                valueExpr: 'code',
                rtlEnabled: true
            }">
                <dxo-label text="الثانية"></dxo-label>
            </dxi-item>

            <!-- عمود البصمه (inout) -->
            <dxi-item dataField="inout" editorType="dxSelectBox" [editorOptions]="{
                dataSource: DeviceAttendanceConfigrationColumnsdropdown,
                displayExpr: 'name',
                valueExpr: 'code',
                rtlEnabled: true
            }">
                <dxo-label text="عمود البصمة"></dxo-label>
            </dxi-item>

            <!-- رقم الجهاز (machinenum) -->
            <dxi-item dataField="machinenum" editorType="dxSelectBox" [editorOptions]="{
                dataSource: DeviceAttendanceConfigrationColumnsdropdown,
                displayExpr: 'name',
                valueExpr: 'code',
                rtlEnabled: true
            }">
                <dxo-label text="حضور انصراف  "></dxo-label>
            </dxi-item>
        </dxi-item>

        <!-- زر الحفظ -->
        <dxi-item itemType="group" [colCount]="3">
            <dxi-item itemType="empty"></dxi-item>
            <dxi-item itemType="empty"></dxi-item>
            
            <dxi-item itemType="button" [buttonOptions]="{
                text: 'حفظ',
                type: 'success',
                width: '100%',
                onClick: onFormSubmit
            }">
            </dxi-item>
        </dxi-item>

    </dx-form>
</div>